export default __webpack_public_path__ + "proximanova-blackit-webfont.woff2";